<script>
import Icon from "@/components/atoms/icon";

export default {
  components: { Icon }
};
</script>

<template>
  <div class="c-shipping-method-header">
    <Icon
      name="cross"
      class="c-shipping-method-header__picto"
    />
    <p class="c-shipping-method-header__label">
      Retrait au drive
    </p>
    <p class="c-shipping-method-header__label">
      à partir de demain 9:00
    </p>
    <p class="c-shipping-method-header__label">
      <strong>Gratuit</strong>
    </p>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/shipping-method.scss";
</style>
